@if (isFetched || performanceReport.length) {
  <div class="flex flex-col gap-3">
    <!-- Caption -->
    <div class="flex items-center justify-between">
      <h3 class="font-semibold text-4">
        {{ translatePrefix + 'report' | translate }} {{ performanceReportDate | date: 'MM/dd/yyyy HH:mm' }}
      </h3>

      <div *ngxPermissionsOnly="Permission.REPORT_EXPORT">
        <app-button
          (onClick)="exportMenu.toggle($event)"
          label="Export"
          size="sm"
          icon="icon-wl-upload"
          iconPosition="left"
          [isDropdown]="true"
          [loading]="isExporting"
          variant="outline-secondary"></app-button>
        <p-menu #exportMenu [model]="exportOptions" [popup]="true">
          <ng-template pTemplate="item" let-item>
            <div class="flex items-center gap-2 p-2 cursor-pointer">
              <img class="w-5 h-5" [src]="item.img" [alt]="item.title" />
              <span>{{ item.title }}</span>
            </div>
          </ng-template>
        </p-menu>
      </div>
    </div>

    <!-- Table -->
    <p-table
      [value]="performanceReport"
      [scrollable]="true"
      dataKey="id"
      [lazy]="true"
      (onSort)="onSort($event)"
      [loading]="isLoading"
      [customSort]="true">
      <ng-template pTemplate="header">
        <tr class="truncate">
          <th
            pFrozenColumn
            [frozen]="true"
            alignFrozen="left"
            frozenColStyle="left"
            [pSortableColumn]="PERFORMANCE_EXPORT_TO_SORT_FIELD[PerformanceExportFieldEnum.USER]!">
            <div class="flex items-center">
              <div class="w-12">{{ 'report.no.' | translate }}</div>
              @if (isUserColumnIncluded) {
                <div>
                  <app-sort-table-header
                    [label]="translatePrefix + 'user' | translate"
                    [sortField]="sortField"
                    [sortOrder]="sortOrder"
                    [field]="
                      PERFORMANCE_EXPORT_TO_SORT_FIELD[PerformanceExportFieldEnum.USER]!
                    "></app-sort-table-header>
                </div>
              }
            </div>
          </th>

          @for (col of visibleColumns; track $index) {
            @if (col.key !== PerformanceExportFieldEnum.USER) {
              <th class="!text-right" [pSortableColumn]="PERFORMANCE_EXPORT_TO_SORT_FIELD[col.key]!">
                <app-sort-table-header
                  [label]="translatePrefix + col.labelKey | translate"
                  [sortField]="sortField"
                  [sortOrder]="sortOrder"
                  [field]="PERFORMANCE_EXPORT_TO_SORT_FIELD[col.key]!"></app-sort-table-header>
              </th>
            }
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item let-i="rowIndex">
        <tr class="truncate">
          <!-- No. -->
          <td pFrozenColumn [frozen]="true" alignFrozen="left" frozenColStyle="left">
            <div class="flex items-center">
              <div class="w-12">{{ i + 1 + (pagination?.page ?? 0) * (pagination?.size ?? 10) }}</div>
              @if (isUserColumnIncluded) {
                <div>{{ item.fullName }}</div>
              }
            </div>
          </td>

          @for (col of visibleColumns; track $index) {
            @switch(col.key) {
              @case (PerformanceExportFieldEnum.NUMBER_OF_NOTES) {
                <!-- Note -->
                <td class="!text-left">{{ item.notes }}</td>
              }
              @case (PerformanceExportFieldEnum.NUMBER_OF_CLICK_CALLS) {
                <!-- Click call -->
                <td class="!text-left">{{ item.clickCalls }}</td>
              }
              @case (PerformanceExportFieldEnum.NUMBER_OF_UPDATED_LEADS) {
                <!-- Updated lead -->
                <td class="!text-left">{{ item.updatedLeads }}</td>
              }
              @case (PerformanceExportFieldEnum.NUMBER_OF_NO_UPDATED_LEADS) {
                <!-- No updated lead -->
                <td class="!text-left">{{ item.noUpdatedLeads }}</td>
              }
              @case (PerformanceExportFieldEnum.NUMBER_OF_TASKS) {
                <!-- Task -->
                <td class="!text-left">{{ item.tasks }}</td>
              }
              @case (PerformanceExportFieldEnum.NUMBER_OF_APPOINTMENTS) {
                <!-- Appointment -->
                <td class="!text-left">{{ item.appointments }}</td>
              }
              @case (PerformanceExportFieldEnum.TOTAL_LEADS_CREATED) {
                <!-- Lead created -->
                <td class="!text-left">{{ item.createdLeads }}</td>
              }
              @case (PerformanceExportFieldEnum.TOTAL_POLICIES_CREATED) {
                <!-- Policy created -->
                <td class="!text-left">{{ item.createdPolicies }}</td>
              }
              @case (PerformanceExportFieldEnum.HOURS_ONLINE) {
                <!-- Hour online -->
                <td class="!text-left">{{ item.hoursOnline }}</td>
              }
            }
          }
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [colSpan]="20">
            <app-empty-table></app-empty-table>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <app-custom-paginator
      [(pagination)]="pagination"
      [totalRecords]="totalReports"
      [options]="options"
      (onChange)="onPagination()"></app-custom-paginator>
  </div>
}
